import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MarginBottomOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { IPageComponentLinksData } from './links.interface';

@Component({
    selector: 'page-component-links',
    templateUrl: './links.html',
    standalone: true,
    imports: [HrefComponent, NgClass, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentLinksComponent>({
    id: 'links',
    name: 'Text or link lines',
    description: 'Component is optimised to work with meganav and footer nav but also usable on content pages',
    image: '/common/cms/links-component.png',
    tags: ['nav', 'menu', 'footer'],
    isAdvanced: true,
    fields: [
        // text lines
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Text Lines',
            itemName: 'Line',
            itemNameField: 'text',
            defaultSize: 3,
            fields: [
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Copy',
                    default: 'This is new line',
                    required: true
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link',
                    description: 'Please use relative paths like: /some-page for internal referrences.',
                    default: undefined
                },
                {
                    key: 'scroll_to_id',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Scroll To Id',
                    default: undefined
                },
                {
                    key: 'scroll_to_offset',
                    type: NICmsContentField.EFieldType.number,
                    title: 'Scroll To Offset (pixels)',
                    default: undefined
                },
                <NICmsContentField.IChoiceField>{
                    key: 'text_style',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Text Style',
                    options: TextStyleOptions,
                    default: undefined
                },
                <NICmsContentField.IChoiceField>{
                    key: 'margin_bottom',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Margin Bottom',
                    options: MarginBottomOptions,
                    default: undefined
                }
            ]
        }
    ]
})
export class PageComponentLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component: IPageComponentLinksData;
}
